import {
  CLEAR_STATE,
  CLEAR_STATEMENT,
  CLEAR_STATEMENTS,

  SAVE_STATEMENT,
  SAVE_STATEMENT_ERROR,
  SAVE_STATEMENT_SUCCESS,

  GET_STATEMENTS,
  GET_STATEMENTS_ERROR,
  GET_STATEMENTS_SUCCESS,

  GET_STATEMENT,
  GET_STATEMENT_ERROR,
  GET_STATEMENT_SUCCESS,

  DELETE_STATEMENT,
  DELETE_STATEMENT_ERROR,
  DELETE_STATEMENT_SUCCESS,

} from './constants';

export default {
  [CLEAR_STATEMENTS](state) {
    state.error = false;
    state.success = false;
    state.loading = false;
    state.statements = [];
    state.statement = false;
  },
  [CLEAR_STATEMENT](state) {
    state.statement = {
      date: false,
      pdf: false,
      Link: false,
    };
  },
  [CLEAR_STATE](state) {
    state.error = false;
    state.success = false;
  },

  [DELETE_STATEMENT](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DELETE_STATEMENT_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [DELETE_STATEMENT_SUCCESS](state) {
    state.success = true;
    state.statements = false;
    state.loading = false;
  },

  [GET_STATEMENTS](state) {
    state.error = false;
    state.loading = true;
  },
  [GET_STATEMENTS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_STATEMENTS_SUCCESS](state, payload) {
    state.statements = payload.data;
    state.paging = payload.paging;
    state.loading = false;
  },

  [SAVE_STATEMENT](state) {
    state.error = false;
    state.success = false;
    state.loading = true;
  },
  [SAVE_STATEMENT_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.loading = false;
  },
  [SAVE_STATEMENT_SUCCESS](state, payload) {
    state.success = true;
    state.loading = false;
    state.statement = payload;
  },

  [GET_STATEMENT](state) {
    state.statement = false;
    state.error = false;
    state.loading = true;
  },
  [GET_STATEMENT_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_STATEMENT_SUCCESS](state, payload) {
    state.statement = payload;
    state.loading = false;
  },
  updateItem(state, payload) {
    state.statement[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/BankStatement/mutations.js